var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"logo-wrapper"},[_c('img',{staticClass:"logo rotate",attrs:{"src":require("@/assets/images/app-logo/humanly-logo.svg")}})])
}]

export { render, staticRenderFns }